import {
  alias, params, string, extend, arrayOf, shape, bool, number
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { wrappedProduct } from './core/RecommendationsProductPodCarousel';

const productModel = extend({}, {
  itemId: string(),
  dataSource: string(),
}, ProductPod.dataModel.product);

export const dataModel = extend({
  recsProducts:
    alias('products').params({
      itemIds: arrayOf(string().isRequired()).isRequired(),
      dataSource: string()
    }).arrayOf(productModel),
});

const batterySystemsMetaData = {
  batteryDesc: string(),
  batteryImageUrl: string(),
  batteryName: string(),
  batteryPlpUrl: string(),
  batteryTitle: string()
};

export const dynamicRecsDataModel = {
  recs: params({
    anchorId: string().isRequired(),
    apiName: string().isRequired(),
    storeId: string(),
    serviceType: string()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string(),
      ...batterySystemsMetaData
    }),
    products: arrayOf(wrappedProduct)
  })
};

export const rvDataModel = {
  uds: params({
    userId: string().isRequired(),
    apiName: string().isRequired(),
    storeId: string(),
    key: string().isRequired(),
    unique: bool()
    // showPrice: bool()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string()
    }),
    products: arrayOf(wrappedProduct)
  })
};

const trendingNearYouWrappedImage = {
  url: string(),
  type: string(),
  subType: string(),
  sizes: arrayOf(string()),
  __typename: string()
};

const trendingNearYouWrappedProduct = {
  product: shape({
    categoryUrl: string(),
    categoryName: string(),
    itemId: string(),
    media: shape({
      images: arrayOf(
        trendingNearYouWrappedImage
      ),
      __typename: string()
    })
  })
};

export const trendingNearYouDataModel = {
  uds: params({
    apiName: string().isRequired(),
    appId: string().isRequired(),
    key: string().isRequired(),
    storeId: string().isRequired(),
  }).shape({
    metadata: shape({
      apiName: string(),
      fallbackModelName: string(),
      modelName: string(),
      title: string(),
      type: string(),
      version: string(),
    }),
    products: arrayOf(trendingNearYouWrappedProduct)
  })
};

export const todaysRecommendationsDataModel = {
  uds: params({
    apiName: string().isRequired(),
    appId: string(),
    columnFamily: string(),
    key: string().isRequired(),
    schema: string(),
    storeId: string(),
    tableName: string(),
    userId: string().isRequired(),
  }).shape({
    metadata: shape({
      apiName: string(),
      fallbackModelName: string(),
      modelName: string(),
      title: string(),
      type: string(),
      version: string(),
    }),
    products: arrayOf(wrappedProduct)
  })
};

export const reorderDataModel = {
  uds: params({
    appId: string(),
    apiName: string().isRequired(),
    cType: string(),
    exItems: string(),
    filter: string(),
    key: string().isRequired(),
    maxProducts: number(),
    model: string(),
    showPrice: bool(),
    storeId: string(),
    tableName: string(),
    userId: string().isRequired()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string(),
    }),
    products: arrayOf(wrappedProduct)
  }),
};
